// extracted by mini-css-extract-plugin
export default {"footer":"RootLayoutFooter_footer__g4bfl"};